import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Settings } from '../settings/settings';
import { State, WebsiteStateStore } from '../website-builder/website.state.store';
import { Registry } from '../registry/registry';
import { Website } from '../website-builder/wedding';
import { SettingsStateStore } from '../settings/settings.state.store';
import { RegistryStateStore } from '../registry/registry.state.store';
import { Router } from '@angular/router';
import { RegistryService } from '../registry/registry.service';
import { NavigationEnd } from '@angular/router';
import { filter, take, takeUntil } from 'rxjs/operators';
import { Http, RequestOptions, Headers } from '@angular/http';
import { environment } from '../../environments/environment';
import { AuthService, User } from '../user/auth.service';
import { Gift } from '../gift/gift';
import { LoadService } from './load-service';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Contribution } from '../track/contribution';
import { UserService } from '../user/user.service';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs';
import { AnalyticsService } from '../analytics/analytics.service';
import { ImageUrlService } from '../shared/services/image-url.service';
@Component({
  selector: 'app-mega-menu',
  templateUrl: './mega-menu.component.html',
  styleUrls: ['./mega-menu.component.scss']
})

export class MegaMenuComponent implements OnInit, OnDestroy {
  @Output() translationDisabled = new EventEmitter<void>();
  showMegaMenu: boolean = false;
  settings: Settings;
  registry: Registry;
  state: State;
  website: Website;
  showTranslate = false;
  contributions: Contribution[]
  @Input() mode: string;
  loaded: boolean;
  private routerSubscription: Subscription;
  translationType: string;
  enableTranslations = false;
  secondLanguage = '';
  secondLanguageCode = '';
  defaultLanguage = 'English';
  user: User;
  translationInProgress: boolean = false;
  translationComplete = false;

  disableSave = false;
  gifts: Gift[];
  numberOfthingsThatRequireTranslation: any;
  editDefaultLanguage: boolean;
  defaultLanguageCode: string;
  isFirstLoad: any;
  alerts: number;
  showMiniLaunch: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(
    private _settingsState: SettingsStateStore,
    private _registryState: RegistryStateStore,
    private _websiteStateStore: WebsiteStateStore,
    private _registryStateStore: RegistryStateStore,
    private router: Router,
    private _authService: AuthService,
    private registryService: RegistryService,
    private _http: Http,
    private _analyticsService: AnalyticsService,
    private loadService: LoadService,
    private _userService: UserService,
    private _registryFirebaseService: RegistryFirebaseService,
    private cdr: ChangeDetectorRef,
    private imageUrlService: ImageUrlService
  ) {



    //on every route change close the visibile modal
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showMiniLaunch = false;
      }
    });

    this.loaded = true;

    this._registryStateStore.getState().subscribe(state => {

      this.gifts = state.gifts;
      this.registry = state.registry;

      this.checkIfRequiresTranslation();
    })

    this._settingsState.getState().subscribe(state => {
      if (state && state.settings) {
        this.enableTranslations = state.settings.enableTranslations;
        this.secondLanguage = state.settings.secondLanguage;
        this.defaultLanguage = state.settings.defaultLanguage || "English";
        ;
        if (this.translationInProgress && !state.settings.translationsInProgress) {
          this.translationComplete = true;
        }
        this.translationInProgress = state.settings.translationsInProgress;
      }
    });

    this._websiteStateStore.getState().subscribe(state => {
      if (state && state.website) {
        this.website = state.website;
        this.checkIfRequiresTranslation();
      } if (state && state.user) {

        this.user = state.user;
      }
    });


  }

  firstLoad() {

    if (this.loadService.isFirstLoad) {
      console.log("FIRST LOAD");
      //  this.showMenu()
      this.loadService.isFirstLoad = false;
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  resetState(): void {
    this.showMiniLaunch = false;
  }
  ngOnInit() {
    this._registryFirebaseService.showMiniLaunchChanged
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(([showPopup, isWebsite]) => {
        this.showMiniLaunch = showPopup;

        if(showPopup){
         this.hideScrollBar();
        } else {
          this.showScrollBar();
        }
        
      });

    this._registryFirebaseService.getInitialMiniLaunchState().subscribe(([showPopup, isWebsite]) => {
      this.showMiniLaunch = showPopup;

      if(showPopup){
        this.hideScrollBar();
       } else {
         this.showScrollBar();
       }
    });

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.resetState();
      }
    });


    this._settingsState.getState().subscribe(state => {
      this.settings = state.settings;
      if (this.settings && this.settings.secondLanguage) {

        this.secondLanguageCode = this._websiteStateStore.getLanguageCode(this.settings.secondLanguage);
      }
      if (this.settings && this.settings.defaultLanguage) {
        this.defaultLanguageCode = this._websiteStateStore.getLanguageCode(this.settings.defaultLanguage)
      }
    });

    if (location.href.endsWith('/add-payment-methods')) {
      this.showMiniLaunch = false;
    }

    this._registryFirebaseService.getContributions(null).subscribe(contributions => {
      this.contributions = contributions;
      this.alerts = this.contributions.filter(x => x.seen != true).length;
    })
    this._registryState.getState().subscribe(state => {
      this.registry = state.registry;

      // this.gifts = state.gifts;
    });

    this._websiteStateStore.getState().subscribe(state => {
      this.website = state.website;

    });

  }
  hideMenu() {
    this.showMegaMenu = false;
    if(this.cdr && !this.cdr['destroyed']){        
      this.cdr.detectChanges();      
   }
  }

  showTranslatePopup() {
    this.showTranslate = true;
    this.hideScrollBar();
    this.translationComplete = false;
    if (this.settings && this.settings.enableTranslations) {
      this.translationType = 'fill'
    }

  }
  closeVisibilityPopup(){
    this._registryFirebaseService.showMiniLaunchPopup(false, false);
    this.showScrollBar();
  }
  showMenu() {
    this.showMegaMenu = true;
  }
  showScrollBar() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
  }
  hideScrollBar() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
  }
  launchClick() {
    if (!this.registry.paid && (!this.registry.hasCustomPaymentMethods)) {
      this.router.navigate(['/registry/add-payment-methods']);
    } else if (!this.registry.paid && (this.registry.hasCustomPaymentMethods)) {
      this.router.navigate(['/visibility']);
    } else {
      this.router.navigate(['/registry/publish/step-3']);
    }
  }


  openPreview() {

    if (this.mode == "website") {
      this.router.navigateByUrl("/" + this.registry.registryName + "?preview=1");
      return;
    }
    if (this.website && this.settings && this.settings.weddingWebsiteEnabled) {
      this.router.navigateByUrl("/" + this.registry.registryName + "/registry" + "?preview=1");
    } else {
      this.router.navigateByUrl("/" + this.registry.registryName + "?preview=1");
    }
  }
  openPopup(popupType) {

    this.registryService.emitGenricPopup(popupType);
  }
  openLinkOrShowPopup(routerUrl) {
    this.router.navigateByUrl(routerUrl);

  }
  backToRegistry() {
    //go back in browser
    this.router.navigate(['/overview']);
  }

  toggleWebsite() {
    this.settings.weddingWebsiteEnabled = !this.settings.weddingWebsiteEnabled;
    this.saveSettings()
  }
  toggleRegistry() {
    this.settings.registryEnabled = !this.settings.registryEnabled;
    this.saveSettings()
  }
  saveSettings() {
    this._settingsState.updateSettings(this.settings);
  }

  disableTranslation() {
    this.enableTranslations = false;
    this.secondLanguage = '';
    this.defaultLanguage = 'English';
    this.settings.enableTranslations = false;
    this.settings.secondLanguage = '';
    this.settings.defaultLanguage = 'English';
    this._websiteStateStore.emitTranlation(false);
    this.translationDisabled.emit();
    this.saveSettings();
    this.showTranslate = false;
    this.registry.translationLanguage = null;
    this._analyticsService.trackEvent('Translation disabled', {});
    this._registryStateStore.updateRegistry(this.registry)

  }
  onToggleChange() {
    if (!this.enableTranslations) {
      this.secondLanguage = '';
      this.defaultLanguage = 'English';
    } else {
      this.translationType = 'replace'
    }
  }
  changeSecondLang() {
    this.defaultLanguage = 'English';
    this.disableSave = false;
    this.secondLanguageCode = this._websiteStateStore.getLanguageCode(this.secondLanguage);
  }
  goToSiteUrl() {
    //navigate to the /settings#site-url"
    if (location.pathname.includes('settings')) {
      const element = document.getElementById('site-url');
      if (element) {
        element.scrollIntoView();
      }
    } else {
      this.router.navigate(['/settings'], { fragment: 'site-url' });
    }


  }

  checkIfRequiresTranslation() {
    if (this.settings && (!this.settings.enableTranslations || !this.settings.secondLanguage)) {
      return false
    }
    this.numberOfthingsThatRequireTranslation = 0;

    let requiresTranslation = false;

    if (this.website) {
      for (let key in this.website) {

        if (this.website.hasOwnProperty(key)) {
          let obj = this.website[key];
          if (key == 'schedule') {
            if (obj && obj.scheduleItems && obj.scheduleItems.length) {
              obj.scheduleItems.forEach(item => {
                this.checkObjectKeysForTranslationAttribute(item, requiresTranslation);
              })
            }

          } else if (key == 'weddingParty') {
            if (obj && obj.partyMembers && obj.partyMembers.length) {
              obj.partyMembers.forEach(member => {

                this.checkObjectKeysForTranslationAttribute(member, requiresTranslation);
              })
            }
          } else if (key == 'questions') {
            if (obj && obj.questions && obj.questions.length) {
              obj.questions.forEach(question => {
                this.checkObjectKeysForTranslationAttribute(question, requiresTranslation);
              })
            }
          }




          this.checkObjectKeysForTranslationAttribute(obj, requiresTranslation);
        }
      }

      if (this.website.weddingEvents && this.website.weddingEvents.length) {
        for (let i = 0; i < this.website.weddingEvents.length; i++) {
          let obj = this.website.weddingEvents[i];
          if (obj) {
            this.checkObjectKeysForTranslationAttribute(obj, requiresTranslation);
          }


          if (obj.attendanceQuestion) {
            this.checkObjectKeysForTranslationAttribute(obj.attendanceQuestion, requiresTranslation);

            if (obj.attendanceQuestion.questionType == 'multi select') {
              for (let i = 0; i < obj.attendanceQuestion.options.length; i++) {
                let objq = obj.attendanceQuestion.options[i];
                if (objq) {
                  if (obj.attendanceQuestion.optionsTranslation && obj.attendanceQuestion.optionsTranslation[i]) {

                  } else {
                    requiresTranslation = true;
                    this.numberOfthingsThatRequireTranslation = this.numberOfthingsThatRequireTranslation + 1;

                  }
                }

              }
            }

          }

          if (obj.rsvpQuestions && obj.rsvpQuestions.length) {
            obj.rsvpQuestions.forEach(question => {
              this.checkObjectKeysForTranslationAttribute(question, requiresTranslation);

              if (question.questionType == 'multi select') {

                for (let i = 0; i < question.options.length; i++) {
                  let obj = question.options[i];
                  if (obj) {
                    if (question.optionsTranslation && question.optionsTranslation[i]) {

                    } else {
                      requiresTranslation = true;
                      this.numberOfthingsThatRequireTranslation = this.numberOfthingsThatRequireTranslation + 1;
                    }
                  }
                }
              }
            })
          }
        }
      }

      if (this.website.travel && this.website.travel.travelInfo && this.website.travel.travelInfo.length) {
        for (let i = 0; i < this.website.travel.travelInfo.length; i++) {

          let obj = this.website.travel.travelInfo[i];
          if (obj) {
            this.checkObjectKeysForTranslationAttribute(obj, requiresTranslation);
          }
        }
      }
    }


    if (this.registry) {
      // loop through all the attributes inside registry and check if any of the properties end with "Translation" and if that property is empty then set requires Translation to true and increment numberofThingsThatRequireTranslation
      for (let key in this.registry) {
        if (this.registry.hasOwnProperty(key)) {
          let obj = this.registry[key];
          this.checkObjectKeysForTranslationAttribute(obj, requiresTranslation);
        }
      }


      // loop through all the gifts and check if any of the properties end with "Translation" and if that property is empty then set requires Translation to true and increment numberofThingsThatRequireTranslation
      if (this.gifts && this.gifts.length) {
        for (let i = 0; i < this.gifts.length; i++) {
          let obj = this.gifts[i];
          if (obj) {
            this.checkObjectKeysForTranslationAttribute(obj, requiresTranslation);
          }
        }
      }
    }
  }

  openMobileMenu() {
    this._userService.emitUpdateHeaderType('showMobileMenu');
  }
  save() {
    this.settings.defaultLanguage = this.defaultLanguage;
    this._settingsState.updateSettings(this.settings);
    this.editDefaultLanguage = false;
  }


  checkObjectKeysForTranslationAttribute(obj: any, requiresTranslation: boolean) {
    if (obj) {
      for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          if (prop.endsWith('Translation')) {
            if (!obj[prop] && obj[prop.replace('Translation', '')]) {
              //    console.log(obj + "_" + prop + " REQUIRES TRANSLATION" + obj[prop.replace('Translation', '')]);
              requiresTranslation = true;
              this.numberOfthingsThatRequireTranslation = this.numberOfthingsThatRequireTranslation + 1;
            }
          }
        }
      }
    }
  }


  saveSettingsAndTranslate(translateAll: boolean = false) {
    let forceEnabledIfDisabled = false;
    

    if (this.registry && this.registry.translationLanguage && this.registry.translationLanguage != this.secondLanguage) {
      translateAll = true;
    }
    else if (this.registry && !this.registry.translationLanguage){
      translateAll = true;
    }
    this.settings.enableTranslations = true;
    this.enableTranslations = true;
    this.settings.secondLanguage = this.secondLanguage;
    this.settings.translationsInProgress = true;
    this.settings.defaultLanguage = this.defaultLanguage;
    
    if(this.registry){
    this.registry.translationLanguage = this.secondLanguage;
    this._registryStateStore.updateRegistry(this.registry)
    }
    this._analyticsService.trackEvent('Translation enabled', {
      translationLanguage: this.secondLanguage
    });
    this.saveSettings();



    if (translateAll) {
      forceEnabledIfDisabled = true;
    } else {
      translateAll = false;
    }
    this.translate(translateAll);

  }

  translate(translateAll = false) {
    
    let forceEnabledIfDisabled = false;

    if (translateAll) {
      this.translationType = 'replace'
    } else {
      this.translationType = 'fill'
    }





    if (this.website.defaultMode) {
      this._websiteStateStore.initWebsite(this.user.userId, this.registry, null, true, true);
    }


    this.registry.translationLanguage = this.secondLanguage;
    this._registryStateStore.updateRegistry(this.registry)

    this.translationInProgress = true;

    //if (this.user != null) {
      this._analyticsService.trackEvent('Translation button clicked', {
        translationLanguage: this.secondLanguage,
        translationType: this.translationType
      });
    this._authService.authToken().pipe(take(1)).subscribe(token => {

      let formValue = {
        token: token,
        enableTranslations: this.enableTranslations,
        secondLanguage: this.secondLanguage,
        defaultLanguage: this.defaultLanguage,
        onlyIfEmpty: this.translationType == 'fill' ? true : false,

      }
      
      const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
      const options = new RequestOptions({ headers: headers });

      return this._http
        .post(environment.firebase.clouldFunctionHost + '/translate', formValue, options)
        .toPromise()
        .then((response: any) => {
          this.disableSave = true;
          this.translationType = null;
          this.showTranslate = true;

          // this.settingsProcessing = false;
          // this._router.navigate(['registry', 'add-payment-methods'])
        })
        .catch((e: any) => {
          // this.settingsProcessing = false;
          this.disableSave = false;

          this.translationType = null;
        })
    })
    //    }
  }

  goToTemplates() {
    this.router.navigateByUrl("/registry/templates")
  }

  // Add this method to handle mouse leave
  handleMouseLeave(event: MouseEvent) {
    const element = event.currentTarget as HTMLElement;
    const rect = element.getBoundingClientRect();
    
    // Only hide if mouse is below the element
    // (event.clientY > rect.bottom) means mouse is below the menu
    // We don't hide if mouse is above (event.clientY < rect.top)
    if (event.clientY > rect.bottom) {
      this.hideMenu();
    }
  }

  getMigratedProfileImageUrl(profileImageUrl: string): string {
    if (!profileImageUrl) return '';
    return this.imageUrlService.migrateToGumlet(profileImageUrl);
  }
}




// WEBPACK FOOTER //
// ./src/app/mega-menu/mega-menu.component.ts